import moment from "moment"
import React from "react"
import { IGroupProduct } from "../../views/ecommerce/group/interfaces"
import Row from "../Row"
import { IInfoGroupProduct } from "./interface"
import { 
    FirstCol, 
    Info, 
    Legend, 
    SecondCol, 
    Space, 
    ThirdCol 
} from "./style"

export const InfoGroupProduct = ({
    group
}: IInfoGroupProduct
): React.ReactElement => {

    return (
        <>
            { 
                group.map((item: IGroupProduct, index: number) => {
                    return (
                        <Row key={index}>
                            <FirstCol>
                                <Legend>Descrição</Legend>
                                <Info>{item.description}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Status</Legend>
                                <Info>{ item.active === null ? "Inativo" : "Ativo" }</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Data da criação</Legend>
                                <Info>{moment(item.created_at).format("DD/MM/YYYY hh:mm")}</Info>
                            </ThirdCol>
                            <Space/>
                        </Row>
                    )
                })
            }
        </>
    )
}